import {Injectable} from '@angular/core';
import {Response} from '@angular/http';

import {Observable,throwError} from 'rxjs';
import {mergeMap, retryWhen, switchMap} from 'rxjs/operators';

import {Credentials} from 'app/login/model/interfaces';
import {CredentialsService} from 'app/login/services/credentials.service';
import {LoginService} from 'app/login/services/login.service';

@Injectable()
export class AuthRequest {

  constructor(
    private _loginService: LoginService,
    private _credentialsService: CredentialsService,
  ) { }

  public handleRequest<T>(request: Observable<T>): Observable<T> {
    return request.pipe(retryWhen((errors) => {
      return errors.pipe(switchMap((error) => {

        // tslint:disable-next-line:no-magic-numbers
        if (error.status === 401 || error.status === 403) {

          return this._credentialsService.hasCredentials()
            .pipe(mergeMap((hasCredentials: boolean) => {
              if (hasCredentials) {
                return this._credentialsService.getCredentials();
              }
              throwError(new Error('No credentials set, cannot authorize'));
            }))
            .pipe(mergeMap((credentials: Credentials) => {
              return this._loginService.login(credentials.username, credentials.password);
            }));
        }

        return throwError(error);
      }));
    }));
  }
}
